<div class="p-15">
  <p class="TXT_TITLE">: : {{ constant.searchGroupEmail }} : :</p>

  <p class="note">NOTE:</p>
  <p class="note">
    {{ constant.activeDirGroupName }} <br />
    {{ constant.activeDirDisplayName }} <br />

    {{ constant.activeDirSearch
    }}<a
      href="https://portal.azure.com/#blade/Microsoft_AAD_IAM/UsersManagementMenuBlade/AllUsers"
    >
      {{ constant.hereLinkButtonTxt }}
    </a>
    {{ constant.orADGroupNameIn }}
    <a
      href="https://portal.azure.com/#blade/Microsoft_AAD_IAM/GroupsManagementMenuBlade/AllGroups"
    >
      {{ constant.hereLinkButtonTxt }}
    </a>
  </p>

  <form
    [formGroup]="form"
    *ngIf="isBrowser"
    style="margin: 0; padding: 0; width: 100%"
    class="mt-15"
  >
    <input type="hidden" formControlName="HdItemAmount" />
    <input type="hidden" formControlName="DoAction" />

    <div class="form-controls">
      {{ constant.searchByGroup }}&nbsp;&nbsp;
      <input
        type="text"
        [(ngModel)]="groupEmail"
        [ngModelOptions]="{ standalone: true }"
        id="TxtFilter"
        class="UTEXT"
        style="width: 250px; color: black"
      />
      <input
        type="button"
        (click)="loadItems()"
        onmouseover="this.style.cursor = 'pointer';"
        id="BtnFilter"
        style="margin-left: 20px; color: black"
        value="SEARCH"
      />
    </div>

    <div class="grid-section" *ngIf="items && items.length > 0">
      <div
        *ngIf="errorMessage"
        style="color: red; text-align: center; padding: 20px"
      >
        <p>{{ errorMessage }}</p>
      </div>

      <nz-table
        #requestItems
        nzBordered
        class="StyleTable"
        [nzData]="items"
        [nzShowPagination]="false"
        [nzPageSize]="items.length"
        *ngIf="!isLoading && !errorMessage"
      >
        <thead>
          <tr>
            <th></th>
            <th></th>
            <th>
              {{ constant.groupNametxt }}
            </th>
            <th>
              {{ constant.groupEmailtxt }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="
              let item of requestItems.data;
              let i = index;
              trackBy: trackByIndex
            "
            [ngClass]="{ LST_B: isHovered[i] }"
            (mouseover)="onMouseOver(i)"
            (mouseout)="onMouseOut(i)"
          >
            <td class="ITEM">{{ i + 1 }}</td>
            <td class="ITEM">
              <input
                type="radio"
                [id]="'itm' + i"
                name="groupSelection"
                [value]="item?.group_mail || ''"
                [checked]="checkQA(item?.group_mail || '')"
                (change)="onRadioButtonChange(item)"
              />
            </td>
            <td class="ITEM">{{ item?.group_name || "N/A" }}</td>
            <td class="ITEM">{{ item?.group_mail || "N/A" }}</td>
          </tr>
          <tr *ngIf="!isLoading && !errorMessage && items.length === 0">
            <td
              colspan="4"
              style="text-align: center; padding: 20px; color: #666"
            >
              {{ constant.noEmailTxt }}
            </td>
          </tr>
        </tbody>
      </nz-table>
    </div>
  </form>
</div>
